export const useFindPharmacyTracking = () => {
  const { GA4_TRACKING_ID, triggerEvent, getContentGroupName } = useGoogleAnalytics()

  const route = useRoute()

  const findPharmacyClickEvent = () => {
    triggerEvent('click', {
      click_item: 'apofinder-landingpage-finden',
      send_to: GA4_TRACKING_ID,
      content_group: getContentGroupName(route.name),
    })
  }

  const findSelectedPharmacyClickEvent = () => {
    triggerEvent('click', {
      click_item: 'apofinder-switch-finden',
      send_to: GA4_TRACKING_ID,
      content_group: getContentGroupName(route.name),
    })
  }

  const findPharmacyCodeScanClickEvent = () => {
    triggerEvent('click', {
      click_item: 'apofinder-landingpage-code-scan',
      send_to: GA4_TRACKING_ID,
      content_group: getContentGroupName(route.name),
    })
  }

  const findSelectedPharmacyCodeScanClickEvent = () => {
    triggerEvent('click', {
      click_item: 'apofinder-switch-code-scan',
      send_to: GA4_TRACKING_ID,
      content_group: getContentGroupName(route.name),
    })
  }

  return {
    findPharmacyClickEvent,
    findPharmacyCodeScanClickEvent,
    findSelectedPharmacyClickEvent,
    findSelectedPharmacyCodeScanClickEvent,
  }
}
